(function () {
  "use strict";

  if (window.__batterySubscriptionPageInitialized) {
    return;
  }

  window.__batterySubscriptionPageInitialized = true;
  var INSURANCE_DEDUCTIBLE_TEXT = "Eigen risico \u20AC99,- per gebeurtenis.";

  function parseJson(raw, fallback) {
    if (!raw) return fallback;

    try {
      return JSON.parse(raw);
    } catch (error) {
      return fallback;
    }
  }

  function toStringValue(value) {
    if (value === null || value === undefined) return "";
    return String(value);
  }

  function formatMoney(cents, currency) {
    if (typeof cents !== "number" || Number.isNaN(cents)) {
      return "";
    }

    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: currency || "EUR",
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function formatCompactMoney(cents, currency) {
    return formatMoney(cents, currency).replace(",00", ",-");
  }

  function getRootCartUrl(pathname) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root + pathname.replace(/^\//, "");
  }

  function getConfig(root) {
    var node = root.querySelector("[data-battery-subscription-page-config]");
    return parseJson(node && node.textContent, {});
  }

  function getCurrencyCode(config) {
    return config && config.currency_code ? config.currency_code : "EUR";
  }

  function normalizeInsuranceKey(variant) {
    var explicitKey = toStringValue(variant && variant.insurance_key).toLowerCase();
    var normalizedTitle = toStringValue(variant && variant.title).trim().toLowerCase();

    if (explicitKey === "insured" || explicitKey === "none") {
      return explicitKey;
    }

    if (normalizedTitle.indexOf("verzekering") > -1 || normalizedTitle.indexOf("insurance") > -1) {
      return "insured";
    }

    return "none";
  }

  function normalizeBatteryCount(variant) {
    var explicitCount = toStringValue(variant && variant.battery_count);
    var normalizedTitle = toStringValue(variant && variant.title).trim().toLowerCase();

    if (explicitCount) {
      return explicitCount;
    }

    if (normalizedTitle.indexOf("2 batter") > -1) {
      return "2";
    }

    if (normalizedTitle.indexOf("1 batter") > -1) {
      return "1";
    }

    return "";
  }

  function getSelectedVariantId(root) {
    var dedicatedInput = root.querySelector("[data-battery-subscription-variant-id]");

    if (dedicatedInput) {
      return dedicatedInput.value;
    }

    var input = root.querySelector("input[name='id']");
    return input ? input.value : "";
  }

  function getQuantity(root) {
    var quantityInput = root.querySelector("input[name='quantity']");
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (!Number.isFinite(quantity) || quantity < 1) {
      return 1;
    }

    return quantity;
  }

  function findVariant(config, variantId) {
    var variants = config && config.variants ? config.variants : [];

    for (var index = 0; index < variants.length; index += 1) {
      if (toStringValue(variants[index].id) === toStringValue(variantId)) {
        return variants[index];
      }
    }

    return null;
  }

  function findVariantBySelection(config, batteryCount, insuranceKey) {
    var variants = config && config.variants ? config.variants : [];
    var desiredBatteryCount = toStringValue(batteryCount);
    var desiredInsuranceKey = insuranceKey === "insured" ? "insured" : "none";

    for (var index = 0; index < variants.length; index += 1) {
      if (
        normalizeBatteryCount(variants[index]) === desiredBatteryCount &&
        normalizeInsuranceKey(variants[index]) === desiredInsuranceKey
      ) {
        return variants[index];
      }
    }

    return null;
  }

  function getSelectedBatteryCount(root, config) {
    var input = root.querySelector("[data-battery-count-input]:checked");

    if (input) {
      return toStringValue(input.value);
    }

    var selectedVariant = findVariant(config, getSelectedVariantId(root));
    var fallbackVariant = config && config.variants && config.variants.length ? config.variants[0] : null;

    return normalizeBatteryCount(selectedVariant) || normalizeBatteryCount(fallbackVariant) || "1";
  }

  function getSelectedInsuranceKey(root, config) {
    var input = root.querySelector("[data-insurance-input]:checked");

    if (input) {
      return toStringValue(input.getAttribute("data-insurance-key") || input.value) || "none";
    }

    var selectedVariant = findVariant(config, getSelectedVariantId(root));
    return normalizeInsuranceKey(selectedVariant) || "none";
  }

  function getDepositVariantId(config, batteryCount) {
    var depositVariantIds = config && config.deposit_variant_ids ? config.deposit_variant_ids : {};
    return depositVariantIds[toStringValue(batteryCount)] || "";
  }

  function buildBundleId(variantId) {
    return ["battery-only", toStringValue(variantId), Date.now().toString(36)].join("-");
  }

  function getInsuranceUpgradeCents(config, batteryCount) {
    var baseVariant = findVariantBySelection(config, batteryCount, "none");
    var insuredVariant = findVariantBySelection(config, batteryCount, "insured");
    var upgradeCents = Number(insuredVariant && insuredVariant.price ? insuredVariant.price : 0) - Number(baseVariant && baseVariant.price ? baseVariant.price : 0);

    if (!Number.isFinite(upgradeCents) || upgradeCents <= 0) {
      return 0;
    }

    return upgradeCents;
  }

  function getInsuranceDescription(config, batteryCount) {
    var upgradeCents = getInsuranceUpgradeCents(config, batteryCount);

    if (upgradeCents > 0) {
      return "Voeg extra bescherming toe voor " + formatCompactMoney(upgradeCents, getCurrencyCode(config)) + " per maand.";
    }

    return "Voeg extra bescherming toe voor je batterij-abonnement.";
  }

  function getInsuranceDisplayLabel(config, batteryCount, insuranceKey) {
    if (insuranceKey !== "insured") {
      return "Ik verzeker de batterij(en) zelf bij mijn voertuig";
    }

    var batteryLabel = batteryCount === "2" ? "2 batterijen" : "1 batterij";
    var upgradeCents = getInsuranceUpgradeCents(config, batteryCount);
    if (upgradeCents > 0) {
      return (
        "Schade- en diefstalverzekering " +
        batteryLabel +
        ", " +
        formatCompactMoney(upgradeCents, getCurrencyCode(config)) +
        " per maand. " +
        INSURANCE_DEDUCTIBLE_TEXT
      );
    }

    return "Schade- en diefstalverzekering " + batteryLabel + ". " + INSURANCE_DEDUCTIBLE_TEXT;

  }

  // The standalone page offers separate batterij-/verzekering keuzes, but add-to-cart still needs
  // the concrete Shopify variant that belongs to that combination.
  function resolveSelection(root, config) {
    var batteryCount = getSelectedBatteryCount(root, config);
    var insuranceKey = getSelectedInsuranceKey(root, config);
    var variant = findVariantBySelection(config, batteryCount, insuranceKey);

    if (!variant && insuranceKey !== "none") {
      insuranceKey = "none";
      variant = findVariantBySelection(config, batteryCount, insuranceKey);
    }

    if (!variant) {
      variant = findVariant(config, getSelectedVariantId(root)) || (config && config.variants && config.variants.length ? config.variants[0] : null);
    }

    if (!variant) {
      return null;
    }

    batteryCount = normalizeBatteryCount(variant) || batteryCount || "1";
    insuranceKey = normalizeInsuranceKey(variant) || insuranceKey || "none";

    return {
      variant: variant,
      batteryCount: batteryCount,
      insuranceKey: insuranceKey
    };
  }

  function buildSubscriptionProperties(state) {
    return {
      "Type": "Batterij abonnement",
      "Aantal batterijen": toStringValue(state.batteryCount),
      "Verzekering": state.insuranceLabel,
      "Maandbedrag": formatMoney(state.monthlyPriceCents),
      "_firmhouse_bundle_type": "battery_only",
      "_firmhouse_bundle_id": state.bundleId,
      "_linked_deposit_variant_id": toStringValue(state.depositVariantId)
    };
  }

  function buildDepositProperties(state) {
    return {
      "Type": "Borg batterij abonnement",
      "Voor product": state.productTitle,
      "_firmhouse_bundle_type": "battery_only",
      "_firmhouse_bundle_id": state.bundleId
    };
  }

  function buildState(root, config) {
    var selection = resolveSelection(root, config);

    if (!selection || !selection.variant) {
      return null;
    }

    return {
      selectedVariantId: selection.variant.id,
      quantity: getQuantity(root),
      batteryCount: selection.batteryCount,
      insuranceKey: selection.insuranceKey,
      insuranceLabel: getInsuranceDisplayLabel(config, selection.batteryCount, selection.insuranceKey),
      monthlyPriceCents: Number(selection.variant.price || 0),
      sellingPlanId: selection.variant.selling_plan_id || "",
      depositVariantId: getDepositVariantId(config, selection.batteryCount),
      productTitle: config.product_title || "",
      bundleId: buildBundleId(selection.variant.id)
    };
  }

  function getSubmissionError(state) {
    if (!state) {
      return "Geen geldige batterijvariant geselecteerd.";
    }

    if (!state.sellingPlanId) {
      return "Geen geldig selling plan gevonden voor deze batterijvariant.";
    }

    if (!state.depositVariantId) {
      return "Geen geldig borgproduct gevonden voor deze batterijkeuze.";
    }

    return "";
  }

  function buildFormDataPayload(item) {
    var formData = new FormData();

    formData.append("id", toStringValue(item.id));
    formData.append("quantity", toStringValue(item.quantity || 1));

    if (item.selling_plan) {
      formData.append("selling_plan", toStringValue(item.selling_plan));
    }

    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        formData.append("properties[" + key + "]", toStringValue(item.properties[key]));
      });
    }

    return formData;
  }

  function submitSingleCartPayload(payload) {
    var firstItem = payload && payload.items ? payload.items[0] : null;
    var hasSellingPlan = Boolean(firstItem && firstItem.selling_plan);
    var requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json"
      }
    };

    window.__batterySubscriptionPageLastPayload = payload;

    if (hasSellingPlan && payload.items.length === 1) {
      requestOptions.body = buildFormDataPayload(firstItem);
    } else {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(payload);
    }

    return fetch(getRootCartUrl("/cart/add.js"), requestOptions).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (rawText) {
          var message = "Cart add failed";
          var parsed = null;

          try {
            parsed = rawText ? JSON.parse(rawText) : null;
          } catch (error) {
            parsed = null;
          }

          if (parsed) {
            message = parsed.description || parsed.message || parsed.errors || rawText || message;
          } else if (rawText) {
            message = rawText;
          }

          window.__batterySubscriptionPageLastError = {
            status: response.status,
            statusText: response.statusText,
            payload: payload,
            responseText: rawText
          };

          throw new Error(typeof message === "string" ? message : JSON.stringify(message));
        });
      }

      return response.json();
    });
  }

  function submitState(state) {
    var payloads = [
      {
        items: [
          {
            id: state.selectedVariantId,
            quantity: state.quantity,
            selling_plan: state.sellingPlanId,
            properties: buildSubscriptionProperties(state)
          }
        ]
      },
      {
        items: [
          {
            id: state.depositVariantId,
            quantity: state.quantity,
            properties: buildDepositProperties(state)
          }
        ]
      }
    ];

    return payloads.reduce(function (promise, payload) {
      return promise.then(function () {
        return submitSingleCartPayload(payload);
      });
    }, Promise.resolve()).then(function () {
      window.__batterySubscriptionPageLastSuccess = {
        state: state,
        payloads: payloads
      };
    });
  }

  function setSubmittingState(root, isSubmitting) {
    var addControl = root.querySelector("[data-battery-subscription-page-add]");
    var button = addControl ? addControl.querySelector("button") : null;

    if (addControl) {
      addControl.toggleAttribute("xo-disabled", isSubmitting);
    }

    if (button) {
      button.disabled = isSubmitting;
      button.setAttribute("aria-busy", isSubmitting ? "true" : "false");
    }
  }

  function setAddButtonAvailability(root, selectedVariant) {
    var addControl = root.querySelector("[data-battery-subscription-page-add]");
    var button = addControl ? addControl.querySelector("button") : null;
    var buttonText = button ? button.querySelector(".xo-btn__text") : null;
    var isAvailable = !selectedVariant || selectedVariant.available !== false;

    if (!addControl || root.__batterySubscriptionSubmitting) {
      return;
    }

    addControl.toggleAttribute("xo-disabled", !isAvailable);

    if (button) {
      button.disabled = !isAvailable;
      button.setAttribute("aria-disabled", !isAvailable ? "true" : "false");
    }

    if (buttonText) {
      buttonText.textContent = isAvailable ? "Toevoegen aan winkelwagen" : "Uitverkocht";
    }
  }

  function syncHiddenVariantInput(root, selectedVariant) {
    var dedicatedInput = root.querySelector("[data-battery-subscription-variant-id]");
    var input = dedicatedInput || root.querySelector("input[name='id']");

    if (!input || !selectedVariant) {
      return;
    }

    if (toStringValue(input.value) !== toStringValue(selectedVariant.id)) {
      input.value = toStringValue(selectedVariant.id);
      input.setAttribute("value", toStringValue(selectedVariant.id));
    }
  }

  function syncBatteryCards(root, batteryCount) {
    var cards = root.querySelectorAll("[data-battery-subscription-battery-card]");

    Array.prototype.forEach.call(cards, function (card) {
      var input = card.querySelector("[data-battery-count-input]");
      var isActive = Boolean(input) && toStringValue(input.value) === toStringValue(batteryCount);

      if (input) {
        input.checked = isActive;
      }

      card.classList.toggle("is-active", isActive);
    });
  }

  function syncInsuranceCards(root, insuranceKey) {
    var cards = root.querySelectorAll("[data-battery-subscription-insurance-card]");

    Array.prototype.forEach.call(cards, function (card) {
      var input = card.querySelector("[data-insurance-input]");
      var isActive = Boolean(input) && toStringValue(input.getAttribute("data-insurance-key")) === toStringValue(insuranceKey);

      if (input) {
        input.checked = isActive;
      }

      card.classList.toggle("is-active", isActive);
    });
  }

  function syncInsuranceCopy(root, config, batteryCount) {
    var descriptionNode = root.querySelector("[data-battery-subscription-insurance-description]");
    var insuranceLabelNode = root.querySelector("[data-battery-subscription-insurance-label]");

    if (descriptionNode) {
      descriptionNode.textContent = getInsuranceDescription(config, batteryCount);
    }

    if (insuranceLabelNode) {
      insuranceLabelNode.textContent = getInsuranceDisplayLabel(config, batteryCount, "insured");
    }
  }

  function syncPrice(root, selectedVariant, config) {
    var priceScope = root.querySelector(".xo-featured-product-content__price");
    var priceNode = priceScope ? priceScope.querySelector(".xo-price__item:not(.xo-price__item--del)") : null;

    if (!priceNode || !selectedVariant) {
      return;
    }

    priceNode.textContent =
      selectedVariant.formatted_price ||
      formatMoney(Number(selectedVariant.price || 0), getCurrencyCode(config));
  }

  function syncSummary(root, selectedVariant, config) {
    var summaryRoot = root.querySelector("[data-battery-subscription-page-summary]");
    var monthlyNode = summaryRoot ? summaryRoot.querySelector("[data-battery-subscription-monthly]") : null;
    var depositNode = summaryRoot ? summaryRoot.querySelector("[data-battery-subscription-deposit]") : null;
    var totalNode = summaryRoot ? summaryRoot.querySelector("[data-battery-subscription-total]") : null;
    var grandTotalNode = summaryRoot ? summaryRoot.querySelector("[data-battery-subscription-grand-total]") : null;
    var depositLabelNode = summaryRoot ? summaryRoot.querySelector("[data-battery-subscription-deposit-label]") : null;
    var totalRowNode = summaryRoot ? summaryRoot.querySelector("[data-battery-subscription-total-row]") : null;
    var batteryCount = normalizeBatteryCount(selectedVariant);
    var batteryCountNumber = parseInt(batteryCount, 10);
    var depositTotalCents = Number(selectedVariant.deposit_price || 0);
    var depositPerBatteryCents = Number.isFinite(batteryCountNumber) && batteryCountNumber > 0
      ? Math.round(depositTotalCents / batteryCountNumber)
      : depositTotalCents;

    if (!summaryRoot || !selectedVariant) {
      return;
    }

    if (depositLabelNode) {
      depositLabelNode.textContent = batteryCount === "2" ? "Borg per batterij" : "Borg batterij";
    }

    if (totalRowNode) {
      totalRowNode.hidden = batteryCount !== "2";
    }

    if (monthlyNode) {
      monthlyNode.textContent =
        selectedVariant.formatted_price ||
        formatMoney(Number(selectedVariant.price || 0), getCurrencyCode(config));
    }

    if (depositNode) {
      depositNode.textContent =
        formatCompactMoney(depositPerBatteryCents, getCurrencyCode(config));
    }

    if (totalNode) {
      totalNode.textContent =
        selectedVariant.deposit_formatted_price ||
        formatCompactMoney(depositTotalCents, getCurrencyCode(config));
    }

    if (grandTotalNode) {
      grandTotalNode.textContent =
        selectedVariant.upfront_total_formatted_price ||
        formatMoney(Number(selectedVariant.upfront_total_price || 0), getCurrencyCode(config));
    }
  }

  function syncSelectedVariant(root, config) {
    var selection = resolveSelection(root, config);

    if (!selection || !selection.variant) {
      return;
    }

    syncBatteryCards(root, selection.batteryCount);
    syncInsuranceCards(root, selection.insuranceKey);
    syncInsuranceCopy(root, config, selection.batteryCount);
    syncHiddenVariantInput(root, selection.variant);
    syncPrice(root, selection.variant, config);
    syncSummary(root, selection.variant, config);
    setAddButtonAvailability(root, selection.variant);

    root.__batterySubscriptionPageSelectedVariantId = toStringValue(selection.variant.id);
    root.__batterySubscriptionPageSelectedBatteryCount = toStringValue(selection.batteryCount);
    root.__batterySubscriptionPageSelectedInsuranceKey = toStringValue(selection.insuranceKey);
  }

  function scheduleSync(root, config) {
    if (!root || !config) {
      return;
    }

    if (root.__batterySubscriptionPageSyncScheduled) {
      return;
    }

    root.__batterySubscriptionPageSyncScheduled = true;

    window.setTimeout(function () {
      root.__batterySubscriptionPageSyncScheduled = false;
      syncSelectedVariant(root, config);
    }, 0);
  }

  function initializeRoot(root) {
    var config = getConfig(root);

    if (!config || !config.variants || !config.variants.length) {
      return;
    }

    syncSelectedVariant(root, config);

    root.addEventListener("change", function () {
      scheduleSync(root, config);
    });

    root.addEventListener("input", function () {
      scheduleSync(root, config);
    });

    root.addEventListener("click", function (event) {
      var batteryCard = event.target.closest("[data-battery-subscription-battery-card]");
      var insuranceCard = event.target.closest("[data-battery-subscription-insurance-card]");

      if (batteryCard) {
        var batteryInput = batteryCard.querySelector("[data-battery-count-input]");

        if (batteryInput) {
          batteryInput.checked = true;
        }

        scheduleSync(root, config);
        return;
      }

      if (insuranceCard) {
        var insuranceInput = insuranceCard.querySelector("[data-insurance-input]");

        if (insuranceInput) {
          insuranceInput.checked = true;
        }

        scheduleSync(root, config);
      }
    });

    // Keep the custom card UI synced with Shopify's hidden variant input and any late theme updates.
    window.setInterval(function () {
      var selectedVariantId = getSelectedVariantId(root);
      var selectedBatteryCount = getSelectedBatteryCount(root, config);
      var selectedInsuranceKey = getSelectedInsuranceKey(root, config);

      if (
        selectedVariantId !== root.__batterySubscriptionPageSelectedVariantId ||
        selectedBatteryCount !== root.__batterySubscriptionPageSelectedBatteryCount ||
        selectedInsuranceKey !== root.__batterySubscriptionPageSelectedInsuranceKey
      ) {
        syncSelectedVariant(root, config);
      }
    }, 250);
  }

  function handleAddClick(event) {
    var addControl = event.target.closest("[data-battery-subscription-page-add]");

    if (!addControl) {
      return;
    }

    var root = addControl.closest("[data-battery-subscription-page-root]");

    if (!root || root.__batterySubscriptionSubmitting) {
      if (root && root.__batterySubscriptionSubmitting) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
      }
      return;
    }

    var config = getConfig(root);
    var state = buildState(root, config);
    var validationMessage = getSubmissionError(state);

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    if (validationMessage) {
      window.alert(validationMessage);
      return;
    }

    root.__batterySubscriptionSubmitting = true;
    setSubmittingState(root, true);

    submitState(state)
      .then(function () {
        window.location.href = getRootCartUrl("/cart");
      })
      .catch(function (error) {
        window.alert(error && error.message ? error.message : "Toevoegen aan winkelwagen mislukt.");
      })
      .finally(function () {
        root.__batterySubscriptionSubmitting = false;
        setSubmittingState(root, false);
      });
  }

  function initializeAllRoots() {
    var roots = document.querySelectorAll("[data-battery-subscription-page-root]");

    Array.prototype.forEach.call(roots, function (root) {
      initializeRoot(root);
    });
  }

  document.addEventListener("click", handleAddClick, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAllRoots);
  } else {
    initializeAllRoots();
  }
})();
